module.exports = __webpack_public_path__ + "static/img/windows_edit_var.ede37d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assignments/cpp/images/windows_edit_var.png
// module id = zFXo
// module chunks = 1